import { TABLE_EMPTY_STATE_LABELS } from '@/components/lemmala-design-system/table/labels'
import type { EmptyStateButton } from '@/components/lemmala-design-system/table/types'

export const clearFiltersAction: EmptyStateButton = {
  label: TABLE_EMPTY_STATE_LABELS.clearFiltersTitle,
  onClick: (context) => {
    context.onClearFilters?.()
  },
}
